import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { ROWS_PER_PAGE_LIST } from '../../../_constants/Const';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../stores/store';
import { TABLE_HEADER } from '../../../_constants/styleConst';

const rCodeRepairPartsTableColumns = [
  { id: 0, label: 'LBL_MODEL' },
  { id: 1, label: 'LBL_PARTS_CATEGORY' },
  { id: 2, label: 'LBL_LIST_NO' },
  { id: 3, label: 'LBL_LIST_VERSION' },
  { id: 4, label: 'LBL_IN_FIGURE_NO' },
  { id: 5, label: 'LBL_PART_NO' },
  { id: 6, label: 'LBL_E_PART_NAME' },
  { id: 7, label: 'LBL_AMOUNT' },
  { id: 8, label: 'LBL_MFW_INFO' },
  { id: 9, label: 'LBL_ECN_NO' },
  { id: 10, label: 'LBL_R_CODE' },
  { id: 11, label: 'LBL_R_CODE_NAME' },
  { id: 12, label: 'LBL_E_R_CODE_NAME' },
] as const;

const RCodeRepairParts: React.FC = () => {
  const { t } = useTranslation();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(ROWS_PER_PAGE_LIST[0]);

  const { rCodePartsList } = useSelector(
    (state: RootState) => state.codeMaster,
  );

  useEffect(() => {
    setPage(0);
  }, [rCodePartsList]);

  const handleChangePage = (
    _: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  return (
    <Box sx={{ mx: '2%' }}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {[...rCodeRepairPartsTableColumns]
                .sort((a, b) => a.id - b.id)
                .map((column, i) => (
                  <TableCell
                    key={`r_code_parts_header_${i}`}
                    sx={{
                      ...TABLE_HEADER,
                      cursor: 'default',
                    }}
                  >
                    {t(column.label)}
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rCodePartsList
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((code, i) => (
                <TableRow key={`r_code_parts_${i}`} hover>
                  <TableCell>{code.modelName}</TableCell>
                  <TableCell>{code.category}</TableCell>
                  <TableCell>{code.listNo}</TableCell>
                  <TableCell>{code.listVersion}</TableCell>
                  <TableCell>{code.inFigureNo}</TableCell>
                  <TableCell>{code.partNo}</TableCell>
                  <TableCell>{code.ePartName}</TableCell>
                  <TableCell>{code.amount}</TableCell>
                  <TableCell>{code.mfwInfo}</TableCell>
                  <TableCell>{code.ecnNo}</TableCell>
                  <TableCell>{code.rCode}</TableCell>
                  <TableCell>{code.rCodeName}</TableCell>
                  <TableCell>{code.erCodeName}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          labelRowsPerPage={t('LBL_ROWS_PER_PAGE')}
          rowsPerPageOptions={ROWS_PER_PAGE_LIST}
          component="div"
          count={rCodePartsList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) =>
            t('LBL_DISPLAY_DATA_LABEL', { 0: from, 1: to, 2: count })
          }
        />
      </TableContainer>
    </Box>
  );
};

export default RCodeRepairParts;
